Apt.fn.make('news.entry', {
	/**
	 * Initialize module
	 */
	init: function() {
		var $photos = $$('photos');

		if ($photos.length) {
			this.photos = Apt.photos.init({
				target: 'ref:photos',
				filters: false,
				query: {
					related: $photos.data('entry')
				}
			});
		}
	},

	/**
	 * Unload module
	 */
	unload: function() {
		if (this.photos) {
			Apt.photos.unload();
		}
	}
});